import {
  commonMutationTypes,
  userDetails,
} from "../../../../../../../utils/commonQueryTypes";
import { IObjectKeys } from "../../../../../../../utils/formTypes";

export interface SwRefData {
  //   key: string;
  num: number;
  list: string;
}

export interface SwConfigVarInput {
  formLabelCaption: string;
  module: string;
  dataStorageType: string;
  tableHeader: string;
  refData?: SwRefData;
}

export interface AddSwConfigVariablesVar extends commonMutationTypes {
  customerID: number;
  input: SwConfigVarInput;
}

export interface AddSwConfigVariablesResult {
  AddSwConfigVariables: boolean;
}

export interface initialFormDataValuesType extends IObjectKeys {
  formLabelCaption: string;
  module: string;
  dataStorageType: string;
  tableHeader: string;
  num: number;
  list: string;
}

export enum SwConfigQueryType {
  ALL_CONFIGS = "ALL_CONFIGS",
  BY_CONFIG_KEY = "BY_CONFIG_KEY",
  BY_MODULE = "BY_MODULE",
  EDUATE_COMPLETE_CONFIG = "EDUATE_COMPLETE_CONFIG",
  EDUATE_BY_MODULE = "EDUATE_BY_MODULE"
}

export interface ConfigQuery {
  queryType: SwConfigQueryType;
  strValue?: string[];
  intValue?: number;
}




export interface GetSwConfigVariablesVar {
  token?: string;
  customerID: number;
  input: ConfigQuery;
}

export interface SwConfigVariables {
  id: number;
  configKey: string;
  mode: string;
  hideThisKey: boolean;
  formLabelCaption: string;
  module: string;
  dataStorageType: string;
  dependsOnPrimaryList: boolean;
  dependsOnSecondaryList: boolean;
  primaryListKey: string;
  secondaryListKey: string;
  tableHeader: string;
  booleanValue: boolean;
  integerValue: number;
  doubleValue: number;
  str1Value: string;
  str2Value: string;
  dateValue: number;
  keyShowIndex: number;
  keyOrderIndex: number;
  customerID: number;
}

export interface GetSwConfigVariablesResult {
  GetSwConfigVariables: SwConfigVariables[];
}

export interface UpdateSwConfigVariablesData {
  id: number;
  config_key: string;
  booleanValue: Boolean;
  integerValue: number;
  doubleValue: number;
  str1Value: string;
  str2Value: string;
  dateValue: number;
}
export interface UpdateSwConfigVariablesVar {
  token?: string;
  customerID: number;
  user_details: userDetails;
  input: UpdateSwConfigVariablesData[];
}
